import { render, staticRenderFns } from "./lngStation.vue?vue&type=template&id=8036496c&scoped=true&"
import script from "./lngStation.vue?vue&type=script&lang=js&"
export * from "./lngStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036496c",
  null
  
)

export default component.exports